import { letterDistribution } from './letterDistribution';

const generateLetter = (): string => {
  const totalWeight = Object.values(letterDistribution).reduce((a, b) => a + b, 0);
  let randomWeight = Math.random() * totalWeight;
  
  for (const [letter, weight] of Object.entries(letterDistribution)) {
    randomWeight -= weight;
    if (randomWeight <= 0) {
      return letter;
    }
  }
  
  return 'A'; // Fallback to 'A' if something goes wrong
};

export const generateBoard = (size: number): string[][] => {
  const board: string[][] = [];
  
  for (let i = 0; i < size; i++) {
    const row: string[] = [];
    for (let j = 0; j < size; j++) {
      row.push(generateLetter());
    }
    board.push(row);
  }
  
  return board;
};
